import templateUrl from './select.tpl.html';

angular
    .module('festzelt-os.components')
    .component('filterSelect', {
        bindings: {
            store: '<',
            col: '<',
        },
        controllerAs: 'vm',
        controller() {
            this.$onInit = () => {
                const predefinedValues = [];
                if (this.col.possibly_empty && (this.col.type === 'string' || this.col.type === 'exact_string_enum')) {
                    predefinedValues.push({
                        label: '- Empty -',
                        value: 'EMPTY'
                    });
                    predefinedValues.push({
                        label: '- Not empty -',
                        value: 'NOT_EMPTY'
                    });
                }

                this.items = _.concat(predefinedValues, _.map(this.col.filter_information.data, (label, value) => {
                    if (_.isObject(label)) {
                        return {
                            label: _.get(label, 'label', ''),
                            value: value
                        };
                    } else {
                        return {
                            label,
                            value
                        };
                    }
                }));
            };

            this.select = (val) => {
                this.store.dispatch('filterCol', {col: this.col, value: val})
            }
        },
        templateUrl: templateUrl
    });



// WEBPACK FOOTER //
// ./src/app/components/state-manager/filter-field/types/filter-type-select.js